import { render, staticRenderFns } from "./SiteAlertsList.vue?vue&type=template&id=629ee064"
import script from "./SiteAlertsList.vue?vue&type=script&lang=js"
export * from "./SiteAlertsList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports